module.exports = __webpack_public_path__ + "assets/img/13.03f55c6c.png";